import { useEffect, useState } from 'react';

export function isElementInViewport(ids: string[]) {
  const [inViewElements, setInViewElements] = useState<string>();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const updatedView: any = {};
        entries.forEach((entry) => {
          updatedView[entry.target.id] = entry.isIntersecting;
        });
        const key = Object.keys(updatedView).find(
          (key) => updatedView[key] === true,
        );
        if (key) {
          setInViewElements(key);
        }
      },
      {
        root: null, // Observe in the viewport
        threshold: 0.1, // 10% visibility
      },
    );

    // Observe each element
    const elements = ids.map((id) => document.getElementById(id));
    elements.forEach((el) => el && observer.observe(el));

    return () => {
      elements.forEach((el) => el && observer.unobserve(el));
    };
  }, []);

  return inViewElements;
}
